import React from "react";
import ReactDOM from "react-dom";
import LogModalElement from "./modal";

const LogModal = {
    open: function (type: string, objectId: any) {
        const container = document.createElement('div')
        document.body.appendChild(container)

        function onClose() {
            ReactDOM.unmountComponentAtNode(container)
        }

        ReactDOM.render((<LogModalElement type={type} objectId={objectId} onClose={onClose}/>), container)
    }
}

export default LogModal
